import React from "react"
import { MdKeyboardArrowLeft } from "react-icons/md"
import { useNavigate } from "react-router-dom"
import { FRONTEND_LINKS } from "../../../../../Constants/FrontendLinks"
import { MobergButton, MobergIconSize, MobergTheme, MobergButtonVariant, MobergButtonShape } from "../../../../../Moberg"

export const PatientsLink = ({ backNavigate=false }) => {
    const navigate = useNavigate()

    return (

        <MobergButton onClick={() => navigate(FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.VISUALIZE.MAIN)} 
            theme={MobergTheme.BLUE} 
            shape={MobergButtonShape.RECTANGLE}
            variant={MobergButtonVariant.CLEAR}
            style={{ marginLeft: 8 }} >
            <MdKeyboardArrowLeft style={{ marginRight: 6 }} size={MobergIconSize.REGULAR} />
            Patients
        </MobergButton>
    )
}
